import styled from "styled-components";
import * as Variable from "../../CSSVariables";

export const GlobalFooterStyle = styled.footer`
  z-index: 1;
  position: relative;
  background-color: #333;
  padding: 15px 0;
  * {
    font: 12px "Cambridge Sans", sans-serif;
    color: ${Variable.white};
  }
  .container {
    max-width: 100%;

    @media only screen and (min-width: ${Variable.tablet}) {
      max-width: 960px;
    }
    @media only screen and (min-width: ${Variable.desktop}) {
      max-width: 1140px;
    }
    @media only screen and (min-width: ${Variable.mediumDesktop}) {
      max-width: 1400px;
    }
  }
  .footer-items {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-flow: wrap;

    @media only screen and (min-width: ${Variable.desktop}) {
      flex-flow: nowrap;
    }
  }
  .footer-menu {
    margin: 0;
    padding-left: 0;
    list-style-type: none;
    position: relative;
    display: flex;
    flex-flow: wrap;
    align-items: center;
    flex: auto;
    width: 100%;

    @media only screen and (min-width: ${Variable.tablet}) {
      flex: 0 0 auto;
      width: auto;
    }

    li {
      a {
        line-height: 22px;
        font-weight: ${Variable.medium};
      }
      &:not(:last-child) {
        a {
          &:after {
            content: "|";
            color: #949494;
            padding: 0 7px;
          }
        }
      }
      .lifebuoy {
        height: 20px;
        width: 20px;
        vertical-align: middle;
      }
    }
  }
  .footer-copyright {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-top: 12px;

    @media only screen and (min-width: ${Variable.tablet}) {
      margin: 0;
    }
    @media only screen and (min-width: ${Variable.desktop}) {
      justify-content: flex-end;
    }

    .scroll-top {
      font-size: 0;

      @media only screen and (min-width: ${Variable.tablet}) {
        display: none;
      }

      img {
        height: 30px;
        width: 30px;
      }
    }
  }
`;
